import { File } from 'lucide-react';
import { useTranslations } from 'next-intl';

export const MetadataDocuments = ({ value }: { value: Array<string> }) => {
  const tCommon = useTranslations('common');

  return (
    <div className="flex flex-col gap-1.5 px-3 py-1">
      {value
        ? value?.map((document) => (
            <div key={document} className="flex items-center gap-2">
              <File className="icon-4 stroke-icon-base" strokeWidth={2.2} />
              <span className="wrap-anywhere">{document}</span>
            </div>
          ))
        : tCommon('noDocuments')}
    </div>
  );
};
